<template>
    <div class="ui__line_main">

    </div>
</template>

<script>
    export default {
        name: "ui-line"
    }
</script>

<style scoped lang="less">
    .ui__line_main {
        width: 100%;
        height: 0.16rem;
        background-color: #F7F8F9;
        position: relative;
    }
</style>
